module.exports = __webpack_public_path__ + "img/upload_image.1a732660.svg";